'use client'
import { LinkExternal } from '@/types/common/LinkExternal'
import s from './Credits.module.scss'
import { useContext, useEffect, useState } from 'react'
import Link from 'next/link'
import React from 'react'
import { Body } from '@/types/common/Body'
import { PortableText } from '@portabletext/react'
import { portableBlockComponents } from '@/utils/portableText'

interface CreditsProps {
    data: DataProps
}

interface DataProps {
    _type: string;
    _ref: string;
    credits: Array<Credit>;
}

interface Credit{
    title: string;
    names: Body[] | null;
}


export default function CreditsOnBottomComponent({
    data
}: CreditsProps) {

    return (
        <div className={s.credits}>
            <div className={s.borderTop}>
            {data && data.credits && data.credits.length > 0 && data.credits.map((credit, index) => {
                return (
                    <div key={index} className={`${s.credit}`}>
                        <p>{credit.title && credit.title}</p>
                        {credit.names &&
                            <div className={s.names}>
                                <PortableText
                                    value={credit.names}
                                    components={portableBlockComponents(credit.names)}
                                />
                            </div>
                        }
                    </div>
                )
            })}
            </div>
            <div></div>
        </div>
    )
}
